import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/leaflypackaging-com/images/services/solution-step1.jpg")